module.exports = __webpack_public_path__ + "static/media/20s.8ef6ec23.pdf";